<template>
  <!-- 同行汇出第一步 -- 数据准备 -->
  <module-section title="同行汇款" class="counterparts-bank-container">
    <el-form
      ref="remittanceForm"
      :model="remittanceInfo"
      :rules="rules"
      label-position="left"
      label-width="180px">
      <el-form-item
        :label="$t('汇款人账号') + '：'"
        prop="payAccount"
      >
        <el-select
          v-model="remittanceInfo.payAccount"
          :placeholder="$t('请选择')"
          @change="changeRemitter"
          style="width:100%">
          <el-option
            v-for="(key, value) in remitterAccountList"
            :key="key"
            :label="key | translateFilter"
            :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('币种') + '：'"
        prop="currencyTypeShow"
      >
        {{ $t(remittanceInfo.currencyTypeShow || '') }}
      </el-form-item>
      <el-form-item
        :label="$t('账户余额') + '：'"
        prop="balanceAvailable"
      >
        {{ remittanceInfo.balanceAvailable || '' }}
      </el-form-item>
      <el-form-item
        :label="$t('收款人帐号') + '：'"
        prop="recAccount"
      >
        <div class="form-item-flex">
          <el-input
            v-model.trim="remittanceInfo.recAccount"
            :placeholder="$t('请输入收款人在本行的9000账号')"
            maxlength="140"
            type="number"
            @blur="checkUserAcc"
          />
          <div class="form-item-flex-tip">
            <span @click="showPayeeList" class="payee-list">{{ $t('收款人名册') }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('收款人名称') + '：'"
        prop="recAccountName"
      >
        <div class="form-item-flex">
          <el-input
            v-model="remittanceInfo.recAccountName"
            :placeholder="$t('请输入收款人名称')"
            type="text"
            @input="handleInputToUpperCase"
          />
          <div class="form-item-flex-tip">
            <el-form-item prop="addPayBookFlag">
              <el-checkbox v-model="remittanceInfo.addPayBookFlag">{{ $t('是否加入收款人名册') }}</el-checkbox>
            </el-form-item>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('汇款金额') + '：'"
        prop="payAmount"
      >
        <div class="form-item-flex">
          <el-input
            v-model="remittanceInfo.payAmount"
            :maxlength="11"
            :placeholder="$t('请输入汇款金额')"
            type="number"
            @blur="queryChargeFee"
          />
          <div v-if="remitterLimit.currency" class="form-item-flex-tip">
            <span>{{ $t('单笔限额') }}：<span style="color: #5A607F;">{{ remitterLimit.amount }}</span> {{ $t(remitterLimit.currency) }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('手续费') + '：'"
        prop="chargeFee"
      >
        {{ remittanceInfo.chargeFee || '' }}
      </el-form-item>
      <el-form-item
        :label="$t('汇款用途') + '：'"
        prop="payUse">
        <el-input
          v-model="remittanceInfo.payUse"
          :placeholder="$t('请输入汇款用途')"
          type="text"
          maxlength="72"
        />
      </el-form-item>
    </el-form>
    <div class="submit-btns">
      <el-button class="reset" @click="resetForm" type="info">{{ $t('重置') }}</el-button>
      <el-button class="next-step" @click="nextStep">{{ $t('下一步') }}</el-button>
    </div>
    <!-- 收款人名册弹窗 -->
    <PayEEListDialog
      :visible="payEEvisible"
      :rec-bank-type="'0'"
      :payee-type="'0'"
      @updatePayeeInfo="onPayeeInfoSelect"
      @cancel="payEEvisible = false"
    />
  </module-section>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import { genRequiredRule, genRegTestRule, genFormatValidateRule } from '@/utils/form/genrules'
import { PATTERN1 } from '../../components/constants'
import PayEEListDialog from '../../components/PayEEListDialog'
import innerApi from '../../api/inner'

export default {
  name: 'counterpartsBankStep1Cache',
  components: {
    ModuleSection,
    PayEEListDialog
  },
  data () {
    const self = this

    return {
      remittanceInfo: { // 汇款信息
        payAccount: '', // 汇款方账号
        payAccountName: '', // 汇款方户名
        payAccountAliasName: '', // 汇款方账户别名
        currencyTypeShow: '', // 币种展示
        currencyType: '', // 币种
        balanceAvailable: '', // 账户余额 - 展示使用
        recAccount: '', // 收款方帐号
        recAccountName: '', // 收款方名称
        addPayBookFlag: true, // 是否添加到收款人名册
        payAmount: '', // 汇款金额
        chargeFee: '', // 手续费
        payUse: '' // 汇款用途
      },
      noList: {
        MSB: self.$t('投资类账户不支持与CBiBank其他账户进行资金互转。') + '<br>' + self.$t('投资类账户之间暂不开通资金互转。') + '<br>' + self.$t('投资类账户暂不支持显示汇入/汇出公司名称。'),
        MSBC: self.$t('快速贸易类账户不支持与CBiBank其他账户进行资金互转。') + '<br>' + self.$t('快速贸易类账户之间暂不开通资金互转。') + '<br>' + self.$t('快速贸易类账户暂不支持显示汇入/汇出公司名称。'),
        MSBD: self.$t('电商类账户不支持与CBiBank其他账户进行资金互转。')
      },

      remitterAccountList: {}, // 汇款方帐号
      remitterLimit: { // 汇款限制
        amount: '',
        currency: ''
      },
      payEEvisible: false // 收款人名册弹窗
    }
  },
  activated () {
    const { routeType } = this.$route.params
    if (routeType === 'NO_CACHE') {
      this.resetForm()
    }
    // 获取汇款方帐号
    const accountMap = this.$_params.getSessionAccountSelect_obj_hasD_new('ALL', true, 2)
    this.remitterAccountList = accountMap

    // 如果是账户查询页面过来的数据, 会带过来accountNo, 则查询该账号相关的数据
    const query = this.$route.query
    if (query.accountNo) {
      this.getAccountInfo(query.accountNo)
    }
    if (query.recAccountName && query.recAccount) {
      this.remittanceInfo.recAccountName = query.recAccountName // 收款方名称
      this.remittanceInfo.recAccount = query.recAccount // 收款方帐号
    }
  },
  computed: {
    rules () {
      return { // 校验规则
        payAccount: genRequiredRule('请选择汇款人账号'),
        recAccount: genRequiredRule('请输入收款人账号'),
        recAccountName: [
          genRequiredRule('请输入收款人名称'),
          genFormatValidateRule(this.$_format.hasChineseChar, '收款人名称不能包含中文')
        ],
        payAmount: [
          genRequiredRule('请输入汇款金额'),
          { required: true, trigger: 'blur', validator: this.amountValidator }
        ],
        payUse: [
          genRequiredRule('请输入汇款用途'),
          genFormatValidateRule(this.$_format.hasChineseChar, '汇款用途不能包含中文'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ]
      }
    },
    amountValidator () {
      return (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('请输入')))
          return
        }
        const { currencyType } = this.remittanceInfo
        if ((currencyType === 'JPY' || currencyType === 'KRW') && (!/.00$/.test(value))) {
          callback(new Error(this.$t('日元和韩元账户汇款金额只能为整数，请重新输入！')))
          return
        }
        callback()
      }
    }
  },
  methods: {
    // 判断收款账户是企业账户或者是下挂账户 是否为本行账号
    checkUserAcc () {
      const { recAccount, payAccount } = this.remittanceInfo
      // 如果没有收款帐号
      if (!recAccount) {
        this.remittanceInfo.recAccountName = ''
        return false
      }
      if (String(recAccount).length !== 12 && String(recAccount).substring(0, 3) !== '919') {
        this.$warn('此账号非法或者非行内账号，请重新录入')
        this.remittanceInfo.recAccount = ''
        this.remittanceInfo.recAccountName = ''
        return false
      }

      innerApi.checkUserAcc({
        recAccount,
        currentBusinessCode: '10100000'
      }).then(res => {
        const { recAccountName } = res

        if (recAccountName) {
          this.$warn('同名账户请使用下挂账号转账进行转账交易')
          this.remittanceInfo.recAccount = ''
          this.remittanceInfo.recAccountName = ''
        } else {
          // 如果已经选了付款账户，则去查MSB以及单笔限额
          if (payAccount) {
            this.checkMsbAccount()
            this.checkSingleLimit()
          }
        }
      })
    },
    // 查询转账手续费
    queryChargeFee () {
      // 如果没有汇款金额或者付款帐号则不往下走
      if (!this.remittanceInfo.payAmount || !this.remittanceInfo.payAccount) return
      this.remittanceInfo.payAmount = Number(this.remittanceInfo.payAmount).toFixed(2)

      const { currencyType, payAccount, payAmount } = this.remittanceInfo
      const formatPayAccount = payAccount.split('|')[0]

      innerApi.queryChargeFee({
        recBankType: '1',
        currentBusinessCode: '10200300',
        systemCode: '1',
        payAmount: payAmount,
        payAccount: formatPayAccount,
        channel: '1103',
        feeType: '001',
        currencyType: currencyType
      }).then(res => {
        if (res.ec === '0') {
          // 金额格式处理
          this.remittanceInfo.chargeFee = this.resetCurrencyAmount(currencyType, res.chargeFee)
        } else {
          this.remittanceInfo.chargeFee = ''
        }
      })
    },
    // 根据传过来的账户号以及businesscode查询该账号相关的数据
    getAccountInfo (accountNo) {
      return innerApi.getAccountInfo({
        accountNo,
        currentBusinessCode: '10200000'
      }).then(res => {
        if (res.ec === '0') {
          const {
            accountNo, currencyType, accountName, showAccountAlias, accountType
          } = res
          const payAccount = accountNo + ' | ' + currencyType + ' | ' + accountName + ' | ' + showAccountAlias + ' | ' + accountType
          this.remittanceInfo.payAccount = payAccount
        }
      })
    },
    // 收款人名册返回值
    onPayeeInfoSelect (info) {
      this.payEEvisible = false
      this.remittanceInfo.recAccountName = info.recAccountName // 收款方名称
      this.remittanceInfo.recAccount = info.recAccount // 收款方帐号
      // 如果有汇款方帐号，则查询是否符合MSB规则
      if (this.remittanceInfo.payAccount) {
        // 查询单笔限额
        this.checkSingleLimit()
        this.checkMsbAccount()
      }

      setTimeout(() => {
        this.$refs.remittanceForm.validateField('recAccount')
        this.$refs.remittanceForm.validateField('recAccountName')
      }, 5)
    },
    // 查看收款人名册
    showPayeeList () {
      if (!this.remittanceInfo.payAccount) {
        this.$warn('请选择付款账号！')
        return
      }
      if (!this.remittanceInfo.currencyTypeShow) {
        this.$warn('付款账号的币种显示异常，请重新选择付款账号！')
        return
      }
      this.payEEvisible = true
    },
    // 改变汇款方帐号
    changeRemitter (e) {
      if (!e) return false
      // 改变账户重置数据]
      this.remitterLimit = {
        amount: '',
        currency: ''
      }

      this.remittanceForm = {
        ...this.remittanceForm,
        ...this.resetObj,
        balanceAvailable: '',
        payAmount: '',
        chargeFee: '',
        currencyTypeShow: '',
        currencyType: ''
      }
      // 判断账户类型
      if (this.noList[e.split('|')[4]]) {
        this.remittanceInfo.payAccount = ''
        this.$warn(
          this.noList[e.split('|')[4]],
          { dangerouslyUseHTMLString: true }
        )
        return false
      }
      // 获取账户余额
      this.getAccountBalance()
      // 查询单笔限额
      this.checkSingleLimit()
      // 如果有收款方帐号，则查询是否符合MSB规则
      if (this.remittanceInfo.recAccount) {
        this.checkMsbAccount()
      }
      // 如果存在汇款金额，则重新去请求转账手续费
      if (this.remittanceInfo.payAmount) {
        this.queryChargeFee()
      }
    },
    // 获取账户余额
    getAccountBalance () {
      // 获取付款账户信息
      const payAccountInfo = this.remittanceInfo.payAccount.split('|')

      return innerApi.getAccountBalance({
        accountNo: payAccountInfo[0],
        currentBusinessCode: '10100000'
      }).then(res => {
        if (res.ec === '0') {
          // 可用余额
          const balanceAvailable = parseFloat(res.balanceAvailable || 0)
          // 币种
          const currencyType = res.currencyType
          // this.remittanceInfo.balanceAvailableOrign = balanceAvailable
          // 金额格式化
          this.remittanceInfo.balanceAvailable = this.resetCurrencyAmount(currencyType, balanceAvailable)
          // 币种
          this.remittanceInfo.currencyTypeShow = this.$_params.getDisplay('GRB_CURRENCY_TYPE', currencyType)
          this.remittanceInfo.currencyType = currencyType
        }
      })
    },
    // 查询单笔限额
    checkSingleLimit () {
      // 获取付款账户信息
      const payAccountInfo = this.remittanceInfo.payAccount.split('|')

      return innerApi.getAccountTransLimit({
        accountNo: payAccountInfo[0],
        recAccount: this.remittanceInfo.recAccount || ''
      }).then(res => {
        if (!res || !res.limitSingle) return
        // 限额处理
        if (payAccountInfo[1] === 'JPY' || payAccountInfo[1] === 'KRW') {
          this.remitterLimit.amount = this.$_format.toCashWithComma_grb(res.limitSingle)
        } else {
          this.remitterLimit.amount = this.$_format.toCashWithComma(res.limitSingle)
        }
        this.remitterLimit.currency = res.cnCryType
      })
    },
    // 查询是否符合MSB规则
    checkMsbAccount () {
      const { payAccount, recAccount } = this.remittanceInfo
      if (!recAccount || !payAccount) return

      const formatRecAccount = payAccount.split('|')[0]
      innerApi.checkMsbAccount({
        ownAcc: formatRecAccount,
        otherAcc: recAccount
      }).then(res => {
        if (!res.result) {
          this.$warn(res.message)
          this.remittanceInfo.recAccount = ''
          this.remittanceInfo.recAccountName = ''
        }
      })
    },
    // 限额校验
    doLimitCheck () {
      const payAccount = this.remittanceInfo.payAccount.split('|')[0]

      const { payAmount, recAccount, currencyType } = this.remittanceInfo
      const data = {
        payAccount,
        payAmount,
        recAccount,
        currencyType,
        currentBusinessCode: 10200010
      }

      innerApi.accLimitQueryGRB(data).then(res => {
        if (res.ec === '0') {
          const payAccountName = this.$_params.getAccountName(payAccount)
          const payAccountAliasName = this.$_params.getAccountAliasName(payAccount)

          const transferMessage = {
            ...this.remittanceInfo,
            payAccount,
            addPayBookFlag: this.remittanceInfo.addPayBookFlag ? '1' : '0',
            payAccountName: payAccountName.trim(),
            payAccountAliasName: payAccountAliasName.trim()
            // balanceAvailable: this.remittanceInfo.balanceAvailableOrign
          }
          this.$router.push({
            name: 'InnerBankOutwardStep2',
            query: transferMessage
          })
        }
      })
    },
    // 下一步
    nextStep () {
      this.$refs.remittanceForm.validate(valide => {
        if (valide) {
          const { currencyType, payAmount, chargeFee, balanceAvailableOrign } = this.remittanceInfo
          const { amount } = this.remitterLimit
          // 日元和韩元账户转账金额只能为整数
          if ((currencyType === 'JPY' || currencyType === 'KRW') && (parseInt(payAmount) !== payAmount)) {
            this.$warn('日元和韩元账户转账金额只能为整数，请重新输入！')
            this.remittanceInfo.payAmount = ''
            this.remittanceInfo.chargeFee = ''
            return false
          }
          if (!payAmount) {
            this.$warn('转账金额不能为空')
            return false
          }
          if (!chargeFee) {
            this.$warn('转账手续费不能为空')
            return false
          }

          const payAmountLimit = this.$_format.removeComma(amount)
          if (payAmount - payAmountLimit > 0) {
            this.$warn('转账金额不能大于单笔限额')
            return false
          }

          // 系统判断金额是否超过账户余额（行内）
          if ((parseFloat(payAmount) + parseFloat(chargeFee)) > parseFloat(balanceAvailableOrign)) {
            this.$warn('转账金额加手续费不能超过账户余额')
            this.remittanceInfo.payAccount = ''
            this.remittanceInfo.chargeFee = ''
            return false
          }
          // 限额校验
          this.doLimitCheck()
        }
      })
    },
    // 收款人名称转大写
    handleInputToUpperCase (e) {
      this.remittanceInfo.recAccountName = e.toUpperCase()
    },
    // 金额格式化
    resetCurrencyAmount (currencyType, amount) {
      if (currencyType === 'JPY' || currencyType === 'KRW') {
        return this.$_format.toCashWithComma_grb(amount)
      } else {
        return this.$_format.toCashWithComma(amount)
      }
    },
    // 重置
    resetForm () {
      this.$refs.remittanceForm.resetFields()
    }
  }
}
</script>
<style scoped lang="less">
  .counterparts-bank-container {
    padding-left: 40px;

    .submit-btns {
      display: flex;
      padding-left: 180px;
      padding-top: 20px;

      .reset {
        min-width: 140px;
      }

      .next-step {
        min-width: 140px;
      }
    }

    .form-item-flex {
      display: flex;
      align-items: center;

      .form-item-flex-tip {
        margin-left: 20px;
        font-size: 14px;
        color: #A1A7C4;

        .payee-list {
          color: #4A6AFF;
          cursor: pointer;
        }
      }
    }

    .el-select, .el-input {
      width: 500px !important;
    }
  }
</style>
